(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-campaign-donation]');
    if (!root) return;

    var productHandle = root.getAttribute('data-product-handle');
    var campaignSlug = root.getAttribute('data-campaign-slug');
    var amountButtons = root.querySelectorAll('[data-amount]');
    var customInput = root.querySelector('[data-custom-amount]');
    var submitButton = root.querySelector('[data-donate-submit]');
    var errorEl = root.querySelector('[data-donate-error]');
    var anonymousCheckbox = root.querySelector('[data-donate-anonymous]');

    var selectedAmount = null;
    var variantId = null;

    fetch('/products/' + productHandle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product niet gevonden');
        return res.json();
      })
      .then(function (product) {
        variantId = product.variants[0].id;
      })
      .catch(function () {
        showError('Het donatieproduct kon niet geladen worden. Neem contact op met JC Pets.');
      });

    function showError(message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearError() {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    function selectAmount(amount) {
      selectedAmount = amount;
      amountButtons.forEach(function (btn) {
        btn.classList.toggle('is-selected', parseInt(btn.getAttribute('data-amount'), 10) === amount);
      });
      customInput.value = '';
      updateSubmitState();
    }

    function updateSubmitState() {
      var valid = selectedAmount && selectedAmount > 0;
      submitButton.disabled = !valid;
    }

    amountButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        clearError();
        selectAmount(parseInt(btn.getAttribute('data-amount'), 10));
      });
    });

    customInput.addEventListener('input', function () {
      clearError();
      amountButtons.forEach(function (btn) {
        btn.classList.remove('is-selected');
      });
      var value = parseInt(customInput.value, 10);
      selectedAmount = value > 0 ? value : null;
      updateSubmitState();
    });

    submitButton.addEventListener('click', function () {
      clearError();
      if (!variantId) {
        showError('Even geduld, het donatieproduct wordt nog geladen.');
        return;
      }
      if (!selectedAmount || selectedAmount < 1) {
        showError('Kies of vul een bedrag in.');
        return;
      }

      submitButton.disabled = true;
      submitButton.textContent = 'Bezig...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: selectedAmount,
              properties: {
                Bedrag: '€' + selectedAmount + ',00',
                Campagne: campaignSlug,
                _campaign_slug: campaignSlug,
                _anoniem: anonymousCheckbox && anonymousCheckbox.checked ? 'ja' : 'nee',
              },
            },
          ],
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(data.description || 'Er ging iets mis.');
            });
          }
          return res.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          showError(err.message || 'Er ging iets mis, probeer het opnieuw.');
          submitButton.disabled = false;
          submitButton.textContent = 'Doneer nu';
        });
    });
  });
})();
